import PrescriberPrescriptionsPage from './PrescriberPrescriptionsPage'

export default PrescriberPrescriptionsPage
